import { InternalChatFormValues, Option } from "@/pages/InternalChats/interfaces/internalChatFormValues";
import { internalChatFormValues } from "@/pages/InternalChats/constants/InternalChatFormValues";

export function buildInternalChatInitialValues(
    managersOpts: Option[],
    reactionsOpts: Option[],
    setsOpts: Option[]
): InternalChatFormValues {
    return {
        ...internalChatFormValues,
        from: managersOpts[0] ?? null,
        assign_to: managersOpts[0] ?? null,
        type_reaction: reactionsOpts[0] ?? null,
        set: setsOpts[0] ?? null,
    };
}